import EffectMod from "@/roc/effects/EffectMod";
import { Calc } from "@/roc/effects/EffectAmount";
class SynergyMod extends EffectMod {
    constructor(amount, index) {
        super(Calc.flat, Math.round(amount), index);
    }
    apply(value) {
        return value + this.__amount;
    }
}
export default SynergyMod;
